import { defineMessages } from "@/i18n";
import en from "./en";

export const libNoticesMessages = defineMessages("lib-notices", en);
